// extracted by mini-css-extract-plugin
module.exports = {"root":"InputMaskNumber_root__Xw1_q","rootError":"InputMaskNumber_rootError__2_1_H","error":"InputMaskNumber_error__3gFhq"};